import type { ComponentProps } from 'react';
import { cn } from '@savvy-kit/lib/utils';

type InputProps = Omit<ComponentProps<'input'>, 'size'> & {
  size?: 'sm' | 'default' | 'lg';
};

/**
 * When updating styles, make sure to update the InputGroupInput component as well.
 */

function Input({ className, type, size = 'default', ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'text-sm placeholder:text-secondary selection:bg-info-foreground-light selection:text-dark h-10 w-full min-w-0 rounded-md border border-light bg-card px-3 py-1 text-dark shadow-xs transition-[color,box-shadow] outline-none',
        // Disabled state
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        // Focus state
        'focus-visible:border-primary focus-visible:ring-border-light focus-visible:ring-2',
        // Invalid state
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        'file:text-dark file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium file:pr-1',
        size === 'sm' && 'h-8 text-xs',
        size === 'lg' && 'h-11 text-base',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
